import React, { useEffect, useState } from 'react';
import './estilos.css';

  const InformacionHistorica = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className="container">
       <div className="row">
          <div className="row-content">
               <div className='ldf_titulo'>
                  <h2>Información Histórica</h2>
                  <hr className='hr-gob'/>
               </div>

                <div className="acordeon-cuerpo">
                      {/*  <div className="acordeon"> */}
                           {/* <div className="contenedor">*/}
                                
                                   <div className="contenido-sieb">
                                      <table className="table table-striped table-bordered acordeonTabla" style={{ textAlign: "center" }}>
                                          <tbody>
                                            <tr>
                                                <td colspan="3"><p>BIENES MUEBLES</p></td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Bienes Muebles Periodo 2012</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/InformacionHistorica/Bienes_Muebles_cuenta_publica_2012_OFICINA_CENTRAL.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Bienes Muebles Periodo 2013</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/InformacionHistorica/Bienes_Muebles_cuenta_publica_2013_OFICINA_CENTRAL.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Bienes Muebles Periodo 2014</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/InformacionHistorica/bienes_muebles_cuenta_publica_2014.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Bienes Muebles Periodo 2015</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/InformacionHistorica/Bienes_Muebles_cuenta_publica_2015_OFICINA_CENTRAL.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Bienes Muebles Periodo 2016 1er. Semestre</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/InformacionHistorica/1er_SEMESTRE_2016_BIENES_MUEBLES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Bienes Muebles Periodo 2016 2do. Semestre</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/InformacionHistorica/2do_SEMESTRE_2016_BIENES_MUEBLES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Bienes Muebles Periodo 2017 1er. Semestre</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/InformacionHistorica/1er_SEMESTRE_2017_BIENES_MUEBLES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            
                                            <tr>
                                                <td colspan="3"><p>SALUD Y BIENESTAR COMUNITARIO 2022</p></td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Trimestre Enero - Marzo</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2022/Enero-Marzo22.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Trimestre Abril - Junio</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2022/Abril-Junio22.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Periodo Enero - Septiembre</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2022/Enero-Septiembre22.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Trimestre Octubre - Diciembre</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2022/Octubre-Diciembre22.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            
                                            <tr>
                                                <td colspan="3"><p>INFORMES DE PROGRAMAS</p></td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Informe de Resultados Indicadores Primer Trimestre 2018</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/InformacionHistorica/Informe_de_resultados_indicadores_1trim2018.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Programas Apoyos Subsidios Primer Trimestre 2018</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/InformacionHistorica/Programas_apoyos_subsidios_1trim2018.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                        </tbody>
                                      </table>
                                   </div>
                             {/*  </div>*/}
                        {/*  </div> */}
                     </div>
      


          </div>
       </div>
    </div>


    )
}


  export default InformacionHistorica
